import api from '@pray/shared/utils/api';

export type PostImportResolveParams = {
  runId: string;
  rowIndex: number;
  artistId: string;
};

export type ResolvedArtistEcho = {
  internal_id: number;
  artist_uuid: string;
  db_name: string | null;
  confidence: string;
};

export type ImportDiffSummaryEcho = {
  added: number;
  changed: number;
  unchanged: number;
  errors: number;
  unmatched: number;
};

export type PostImportResolveResponse = {
  resolved_artist: ResolvedArtistEcho;
  diff_summary: ImportDiffSummaryEcho;
};

export const postImportResolve = async ({
  runId,
  rowIndex,
  artistId,
}: PostImportResolveParams): Promise<PostImportResolveResponse> => {
  const url = '/web/studio/superfunnel/import/resolve';
  const body = { run_id: runId, row_index: rowIndex, artist_id: artistId };
  const response = await api.executePostRequest(url, body);
  return (response.data as { data: PostImportResolveResponse }).data;
};
